import React from "react";
import "./HostImageGrid.css";

const isVideoUrl = (url) => /\.(mp4|mov|webm)(\?.*)?$/i.test(url);

const HostImageGrid = ({ experienceImages, onViewAllClick }) => {
  return (
    <div onClick={onViewAllClick} className="grid-container">
      {experienceImages.slice(0, 6).map((media, index) => {
        const isVideo = isVideoUrl(media);
        return (
          <div
            key={index}
            className={`image-wrapper ${index === 0 ? "large-image" : ""}`}
          >
            {isVideo ? (
              <video
                src={media}
                className="image"
                muted
                autoPlay
                playsInline
                loop
              />
            ) : (
              <img
                src={media}
                alt={`Experience ${index + 1}`}
                className="image"
                loading="lazy"
                decoding="async"
              />
            )}
            {index === 5 && experienceImages.length > 6 && (
              <div className="overlay">
                <span className="more-text Satoshi">
                  +{experienceImages.length - 6}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HostImageGrid;
